import { Controller } from "@hotwired/stimulus"
import CryptoJS from "crypto-js"

export default class extends Controller {
  static targets = ["revealButton", "noteContent", "title"]
  static values = {
    encryptedMessage: String,
    encryptedLabel: String,
    key: String,
    revealUrl: String
  }

  connect() {
    this.decryptLabel()
  }

  decryptLabel() {
    if (!this.hasTitleTarget) return
    if (!this.encryptedLabelValue || !this.keyValue) return

    try {
      const label = this.decryptToUtf8(this.encryptedLabelValue, this.keyValue)
      if (label) {
        this.titleTarget.textContent = label
      }
    } catch (e) {
      // Invalid key or corrupted ciphertext — leave the default "Secure Note" placeholder.
    }
  }

  // CryptoJS.AES.decrypt does not throw on garbage input. It returns a WordArray
  // that Utf8-decodes to empty string, whitespace, or throws on malformed UTF-8.
  decryptToUtf8(ciphertext, key) {
    const decrypted = CryptoJS.AES.decrypt(ciphertext, key)
    return decrypted.toString(CryptoJS.enc.Utf8).trim()
  }

  reveal(event) {
    event.preventDefault()
    fetch(this.revealUrlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(data => {
      const note = this.decryptToUtf8(this.encryptedMessageValue, this.keyValue)

      this.noteContentTarget.textContent = note
      this.noteContentTarget.style.display = 'block'
      this.revealButtonTarget.style.display = 'none'
    })
    .catch(error => console.error('Error:', error))
  }
}
